import { render, staticRenderFns } from "./apartment-price-cards.vue?vue&type=template&id=27ec85f0&scoped=true&"
import script from "./apartment-price-cards.ts?vue&type=script&lang=ts&"
export * from "./apartment-price-cards.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-price-cards.scss?vue&type=style&index=0&id=27ec85f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ec85f0",
  null
  
)

export default component.exports